import React from 'react';
import PropTypes from 'prop-types';

import RichTextEditor from 'components/RichTextEditor';

import './ProductionAssumptionsPage.scss';

const ProductionAssumptionsPage = ({
  title,
  content,
  onTitleChange,
  onContentChange,
  canEdit,
  printLayoutHeader,
  printLayoutFooter,
  classNamePrefix,
}) => {
  const layoutClassName = `${classNamePrefix || ''}print-layout`;

  return (
    <div className={`${layoutClassName} production-assumptions-page-shell`}>
      {printLayoutHeader}
      <div className="production-assumptions-page">
        <input
          className="production-assumptions-page__title"
          value={title}
          onChange={event => onTitleChange?.(event.target.value)}
          disabled={!canEdit}
          aria-label="Production assumptions section heading"
        />
        <RichTextEditor
          className="production-assumptions-page__editor"
          value={content}
          onChange={onContentChange}
          disabled={!canEdit}
          placeholder="Add assumptions, notes, terms, or production context..."
          minHeight="8.4in"
        />
      </div>
      <div style={{ flexGrow: 1 }} />
      {printLayoutFooter}
    </div>
  );
};

ProductionAssumptionsPage.defaultProps = {
  title: 'Production Assumptions & Notes',
  content: '',
  onTitleChange: null,
  onContentChange: null,
  canEdit: false,
  classNamePrefix: '',
};

ProductionAssumptionsPage.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  onTitleChange: PropTypes.func,
  onContentChange: PropTypes.func,
  canEdit: PropTypes.bool,
  printLayoutHeader: PropTypes.node.isRequired,
  printLayoutFooter: PropTypes.node.isRequired,
  classNamePrefix: PropTypes.string,
};

export default ProductionAssumptionsPage;
